import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SkapaArende = lazy(() => import("@/pages/info/SkapaArende"));

export const Route = createFileRoute("/skapa-arende")({
  head: () => seoHead("/skapa-arende", { description: "Beskriv ditt ärende så återkommer vi så snart som möjligt. Du får ett referensnummer direkt på mejl." }),
  component: () => <SkapaArende />,
});
